export default "__VITE_ASSET__cz7IlMNw__"